<template>
    <div class="reservation-voucher-list">
        <div v-if="vouchers && vouchers.length > 0">
            <div class="trip-label" v-if="showLabel">Zľavy</div>

            <table>
                <tr class="divider-table-border-bottom" v-for="voucher in vouchers">
                    <td>
                        {{ voucher.code }}

                        <button class="btn-link text-grey remove-voucher-button" @click="removeVoucher(voucher.code)">odstrániť</button>
                    </td>

                    <td class="price-cell">{{ formatPrice(-1 * voucher.amount) }}</td>
                </tr>
            </table>

            <div class="divider" v-if="showDivider" />
        </div>
    </div>
</template>

<script lang="ts" setup>
import { Voucher } from '../types';
import { usePrice } from '../modules/usePrice';
import { useReservation } from '../modules/useReservation';

const { formatPrice } = usePrice();
const { removeVoucher } = useReservation();

interface Props {
    vouchers: Voucher[]
    showLabel?: boolean;
    showDivider?: boolean;
}

withDefaults(defineProps<Props>(), {
    showLabel: true,
    showDivider: true,
});
</script>
